import app from '../main'
import * as types from './mutation-types'

export const statelang = {
  lang: 'en'
}

export const mutations = {
  [types.SET_LANG] (state, payload) {
    app.$i18n.locale = payload
  },
  setLang (state, lang) {
    state.lang = lang
  },
  setConfig (state, config) {
    state.config = config
    state.languages = config.main.language
  },
  setLanguages (state, languages) {
    state.languages = languages
  },
  setCustomerID (state, customerID) {
    state.customer_id = customerID
  },
}

export const actions = {
  setLang ({ commit }, payload) {
    commit(types.SET_LANG, payload)
  }
}

export const getters = {
  lang: state => state.lang,
  config: state => state.config,
  languages: state => state.languages,
  customer_id: state => state.customer_id
}



// WEBPACK FOOTER //
// ./src/store/mutations.js